<div *ngIf="!showOnlyRouterOutLetPage" class="col-md-12 row clear-all flow-content">
  <app-header *ngIf="enableHeader"></app-header>
  <div class="container m-auto">
    <div class="top-container">
      <div *ngIf="enableBreadCrumbFeature" class="breadcrumb-container flex-20">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <!-- {{enableBreadCrumbFeature}} {{hideBreadcrumb}} //gives false true -->
      <div *ngIf="enableBreadCrumbFeature  || hideBreadcrumb" class="disp-none">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div [ngClass]="enableBreadCrumbFeature ? 'content-container flex-80' : 'content-container' ">
        <!-- class="content-container"  -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-footer *ngIf="enableFooter"></app-footer>
</div>
<div *ngIf="showOnlyRouterOutLetPage">
  <router-outlet></router-outlet>
</div>